// extracted by css-extract-rspack-plugin
export default {"cls1":"QuestionStyles-cls1_kBW","cls2":"QuestionStyles-cls2_l5P QuestionStyles-cls1_kBW"};